/**
 * @file Components/Sections/WhyChooseUs.jsx
 * @description Why Choose Us section highlighting competitive advantages,
 * trust factors, and unique selling points of Nikaba Travels.
 */

import React from 'react';

const WhyChooseUs = () => {
  return (
    <section className="py-12 text-center">
      <h2 className="text-3xl font-bold mb-8">Why Choose Our Services?</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {['Expertise', 'Tailored Solutions', 'Results-Driven'].map((title, index) => (
          <div key={index} className="bg-white p-6 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold mb-4">{title}</h3>
            <p className="text-gray-600">
  {title === 'Expertise' 
    ? 'At Nikaba, we bring years of travel industry experience to curate unforgettable journeys.' 
    : title === 'Tailored Solutions' 
    ? 'Discover personalized travel packages designed to suit your unique preferences with Nikaba.' 
    : 'Experience exceptional service and create lasting memories with Nikaba\'s expert travel solutions.'}
</p>

          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;